import PersonRecoveryGoal from './PersonRecoveryGoal';

export default PersonRecoveryGoal;
